import { render } from "./EdoDocumentAdditionalTitles.vue?vue&type=template&id=c0451f0c&scoped=true"
import script from "./EdoDocumentAdditionalTitles.vue?vue&type=script&lang=js"
export * from "./EdoDocumentAdditionalTitles.vue?vue&type=script&lang=js"

import "./EdoDocumentAdditionalTitles.vue?vue&type=style&index=0&id=c0451f0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0451f0c"]])

export default __exports__